import { BreakLevel } from "@decisions/server/DecisionsFramework";

export interface IValidationOptions {
  id: string;
  title: string;
  readonly description: string;
  readonly level: BreakLevel;
  readonly gotoAction?: (entry: ValidationEntry) => void;
  readonly ignoreAction?: (entry: ValidationEntry, isIgnored: boolean) => void;
  readonly onClick?: (event: { event: MouseEvent; entry: ValidationEntry }) => void;
  readonly onContextMenu?: (event: { event: MouseEvent; entry: ValidationEntry }) => void;
  readonly isBreakingIssue?: boolean;
  readonly isIgnored?: boolean;
  readonly imageUrl?: string;
  readonly entityTypeName?: string;
  readonly validationItemType?: string;
}

/**
 * Duplication of ValidationEntry from MVC project
 */
export class ValidationEntry {
  public id: string;
  public title: string;
  public get description() {
    return this.options.description;
  }
  public get level() {
    return this.options.level;
  }
  public get gotoAction() {
    return this.options.gotoAction;
  }
  public get ignoreAction() {
    return this.options.ignoreAction;
  }
  public get onClick() {
    return this.options.onClick;
  }
  public get onContextMenu() {
    return this.options.onContextMenu;
  }
  public get isBreakingIssue() {
    return this.options.isBreakingIssue;
  }
  public get isIgnored() {
    return this.options.isIgnored;
  }
  public get imageUrl() {
    return this.options.imageUrl;
  }
  public get entityTypeName() {
    return this.options.entityTypeName;
  }
  public get validationItemType() {
    return this.options.validationItemType;
  }

  constructor(private options: IValidationOptions) {
    this.title = this.options.title;
    this.id = this.options.id;
  }
} 
